'use client'
import {
    Landmark,
    MapPin,
    Handshake,
    GraduationCap,
} from "lucide-react";

const areasOfWork = [
    {
        title: "Central Government Projects",
        icon: Landmark,
        iconColor: "#10B981",
        bgColor: "#C9F7DC",
        description: "Through its engagement with MSDE and NSDC, Medhavi Foundation operates nine Pradhan Mantri Kaushal Kendras (PMKKs) across India. These centres support Government of India skill development initiatives, including PMKVY and programmes implemented by five Central Ministries. They offer short-term training, Recognition of Prior Learning (RPL), reskilling and upskilling opportunities, with programmes designed around evolving industry needs and national skilling priorities.",
    },
    {
        title: "State Government Projects",
        icon: MapPin,
        iconColor: "#4F8DF7",
        bgColor: "#D1E2FC",
        description: "With partnerships spanning 20+ state-led skilling missions across India, Medhavi Foundation delivers skill development initiatives tailored to regional needs. Its collaborations with State Skill Development Missions, including UPSDM, THLM, Samagra Shiksha, DAY-NULM, NIELIT, PBSSD and others, strengthen the link between learning and employment, equipping trainees with relevant skills for today’s industry.",
    },
    {
        title: "CSR Projects",
        icon: Handshake,
        iconColor: "#A64DD8",
        bgColor: "#EBD0F4",
        description: "Medhavi Foundation works with leading CSR partners, including Emami, Ambuja Neotia, Tata Steel, HDFC Parivartan and ECL, to expand access to inclusive skill development. These collaborations support underserved communities and Self-Help Groups (SHGs) by creating opportunities for education, employment and entrepreneurship, contributing to sustainable livelihoods across diverse regions.",
    },
    {
        title: "Self-Financed Projects",
        icon: GraduationCap,
        iconColor: "#F59E0B",
        bgColor: "#FFF0BD",
        description: "Through its initiatives with Medhavi Skills University, Medhavi Foundation supports self-financed skill development programmes designed to address local employment needs. These include Electrical and Plumbing certification programmes at the Mahatma Gandhi Centre in Ziro, Arunachal Pradesh, in collaboration with Helping Hands NGO, along with a Diploma in Hospitality and Hotel Operations offered at the Aizawl Centre.",
    },
];


const AreasOfWork = () => {
    return (
        <section className="w-full bg-white py-12 my-0 md:mt-5">
            <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)]">
                <h2
                    className="mb-4 md:mb-10 text-2xl font-saans-bold font-semibold text-gray-900 sm:text-3xl lg:text-[42px]"
                    style={{ fontFamily: "saans-bold" }}
                >
                    Areas of Work
                </h2>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
                    {areasOfWork.map((item) => {
                        const Icon = item.icon;

                        return (
                            <div
                                key={item.title}
                                className="flex min-h-110.5 flex-col rounded-lg p-4"
                                style={{ backgroundColor: item.bgColor }}
                            >
                                <div className="flex my-3 h-15 w-15 shrink-0 items-center justify-center rounded-full bg-white"
                                >
                                    <Icon
                                        size={30}
                                        strokeWidth={1.7}
                                        className="text-white"
                                        style={{ color: item.iconColor }}
                                    />
                                </div>

                                <h3 className="mb-2 text-[18px] font-bold leading-[1.4] text-black">
                                    {item.title}
                                </h3>

                                <p className="text-[15px] leading-[1.6] text-[#111827]">
                                    {item.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    )
}

export default AreasOfWork
